import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class NotificationsService {

  private notificationEmitter = new EventEmitter<string>();

  constructor() {}

  emitNotification(notification: string): void {
    this.notificationEmitter.emit(notification);
  }

  getNotifications(): EventEmitter<string> {
    return this.notificationEmitter;
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/notifications.service.ts